(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const announceheight = document.querySelector(".section-announcement");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		headerDetails.addEventListener("toggle", function (e) {
			const colorScheme = this.querySelector("#menu-drawer").dataset.colorScheme;
			header.classList.toggle(colorScheme);
		});

		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > announceheight.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
				document.querySelector('body').classList.add('scrolled-header');
			} else if (scrollTop <= announceheight.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
				document.querySelector('body').classList.remove('scrolled-header');
			}
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();

	// When child menu items extend beyond the container, need to change the childmenue opening direction.
	const headerSubMenu = () => {
		const dir = document.querySelector('html').getAttribute("dir");
		const listMenu = document.querySelector(".header__menu .list-menu");
		const listMenuRect = listMenu.getBoundingClientRect();

		const allSubmenus = listMenu.querySelectorAll(".header__submenu .list-menu-has-child .header__submenu")
		allSubmenus.forEach(item => {
			const itemRect = item.getBoundingClientRect();
			if(dir === "ltr"){
				if(itemRect.right > listMenuRect.right){
					item.style.left = "auto";
					item.style.right = "100%";
				}
			} else {
				if(itemRect.left < listMenuRect.left){
					item.style.left = "100%";
					item.style.right = "auto";
				}
			}
		});
	}

	headerSubMenu();
})();

